import { DesignEntity } from '@/lib/enums';
import applyMetrics from './metrics';
import normalize from './normalize';

export default function deriveActivity({
  activityId,
  deriveMetrics,
  library,
  metrics,
  snapshot,
}) {
  // Add default properties and normalize the activity data.
  const activity = normalize({
    activity: snapshot.entities.activities[activityId],
    library,
    snapshot,
  });

  if (deriveMetrics) {
    const role =
      activity.owner_type === DesignEntity.ROLE
        ? snapshot.entities.roles[activity.owner_uuid]
        : null;
    const group = role?.group_uuid
      ? snapshot.entities.groups[role.group_uuid]
      : null;

    // Apply the activity metrics directly to the activity.
    activity.__metrics = {
      ...activity.__metrics,
      self: applyMetrics({
        activity,
        role,
        group,
        metrics,
      }),
    };
  }

  return activity;
}
